import ValidationType from '../ValidationType';
import { datesAreEqual, dateIsBefore } from "../../dateutil";
import moment from 'moment-timezone';

class EqualsDateField extends ValidationType {

  get comparesField() {
    return true
  }

  validateResponseWithValidation(fieldResponse, validation, formResponse = null) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      if (validation.target) {
        const targetFieldResponse = formResponse
          ? fieldResponse.recapResponse.getFieldResponseForFieldInstanceIdAndFormResponseId(validation.target.id, formResponse.id)
          : fieldResponse.recapResponse.getFieldResponseForFieldInstanceId(validation.target.id);
        const current = moment(fieldResponse.currentValue).utcOffset(moment(fieldResponse.currentValue).utcOffset() ).format('YYYY-MM-DD');
        const compare = moment(targetFieldResponse.currentValue).utcOffset(moment(targetFieldResponse.currentValue).utcOffset()).format('YYYY-MM-DD');
        let compare_print = compare;
        if (!moment(targetFieldResponse.currentValue).isValid()){
          compare_print = "(blank value)";
        }

        if ( !datesAreEqual(current, compare)) {
          const error = this.createValidationError({
            fieldResponse,
            key: 'ERROR_EQUAL_SPECIFIED_FIELD_EX',
            values: { value: targetFieldResponse.currentValue },
            message: `Value should be equal to:  '${compare_print}'`,
          });
          errors.push(error);
        }
      } else {
        console.warn("No target present for validation", validation);
      }
    }
    return errors;
  }
}

export default EqualsDateField;
